export const SEND_REQUEST_API = 'client/application/';
